import React from 'react';
import { BEAT, metrics } from '../../data/reel';
import { SceneProps } from '../../types/reel';
import { easeOut, progress } from '../../utils/reelMath';
import { SceneLayer } from './SceneLayer';

/** Each metric slams in on its own beat and stacks. */
export function MetricsScene({
  time,
  scene
}: SceneProps) {
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.12} data-id="element-87" data-mp="396vxw4svxleh">
      {() => <div className="absolute inset-0 flex items-center bg-cream" data-id="element-88" data-mp="2lgt8jwgcutjk">
          <ul className="ml-[150px] space-y-2" data-id="element-89" data-mp="2ghgm3ctebohi">
            {metrics.map((m, i) => {
          const at = scene.start + i * BEAT;
          const r = easeOut(progress(time, at, at + 0.25));
          const shown = time >= at;
          return <li key={m.label} className="flex items-baseline gap-8" style={{
            opacity: shown ? 0.3 + 0.7 * r : 0,
            transform: `translateX(${(1 - r) * -40}px) scale(${1.05 - 0.05 * r})`,
            transformOrigin: 'left center'
          }} data-id="element-90" data-mp="2pjyanxwiwt7o" data-mpi={i}>
                  <span className="w-[800px] text-[190px] font-medium leading-[1] tracking-[-0.05em] text-sage" data-id="element-91" data-mp="1zzkljb6bosu7">{m.value}</span>
                  <span className="text-[64px] font-medium tracking-[-0.04em] text-ink" data-id="element-92" data-mp="24yfev71x1zsk">{m.label}</span>
                </li>;
        })}
          </ul>
        </div>}
    </SceneLayer>;
}